export const TOGGLE_DEVICE = 'TOGGLE_DEVICE'
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const TOGGLE_NAVBAR_MENU = 'TOGGLE_NAVBAR_MENU'
export const EXPAND_MENU = 'EXPAND_MENU'
export const SWITCH_EFFECT = 'SWITCH_EFFECT'
export const LOGIN = 'LOGIN'
export const SET_USER = 'SET_USER'
export const SET_PERMISSIONS = 'SET_PERMISSIONS'
export const LOGOUT = 'LOGOUT'
